module.exports = __webpack_public_path__ + "28b67065/img/note-edit-icon.acae1669.svg";